/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2025-11-25 12:26:02
 * @LastEditTime: 2026-06-24 02:08:43
 * @Description: 
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { markManualLanguageSelection } from '../../hooks/useRegionLanguage';
import { buildLocalizedPath } from '../../utils/languageRouting';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'hk', name: '繁體中文', flag: '🇭🇰' },
  { code: 'cn', name: '简体中文', flag: '🇨🇳' },
  { code: 'jp', name: '日本语', flag: '🇯🇵' },
  { code: 'kr', name: '한국어', flag: '🇰🇷' },
  { code: 'th', name: 'แบบไทย', flag: '🇹🇭' },
  { code: 'vn', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ug', name: 'ئۇيغۇرچە', flag: '🇨🇳' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = languages.find(lang => lang.code === i18n.resolvedLanguage) || languages[0];
  const isRtl = currentLanguage.code === 'ug';

  const handleLanguageChange = (languageCode: string) => {
    markManualLanguageSelection();
    i18n.changeLanguage(languageCode);
    setIsOpen(false);

    if (typeof window !== 'undefined') {
      const localizedPath = buildLocalizedPath(languageCode, window.location.pathname, __BASE_PATH__);
      window.location.assign(localizedPath);
    }
  };

  return (
    <div className="relative" dir={isRtl ? 'rtl' : 'ltr'}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-black/10 hover:bg-black/20 transition-colors cursor-pointer whitespace-nowrap"
      >
        <span className="text-lg">{currentLanguage.flag}</span>
        <span className="text-sm font-medium text-white hidden sm:block">
          {currentLanguage.name}
        </span>
        <i className="ri-arrow-down-s-line text-gray-600"></i>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          ></div>
          <div className={`absolute mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-20 ${isRtl ? 'left-0' : 'right-0'}`}>
            <div className="py-2">
              {languages.map((language) => (
                <button
                  key={language.code}
                  onClick={() => handleLanguageChange(language.code)}
                  dir={language.code === 'ug' ? 'rtl' : 'ltr'}
                  className={`w-full flex items-center gap-3 px-4 py-2 hover:bg-gray-50 transition-colors cursor-pointer ${
                    language.code === 'ug' ? 'text-right' : 'text-left'
                  } ${
                    i18n.resolvedLanguage === language.code ? 'bg-yellow-50 text-yellow-800' : 'text-gray-700'
                  }`}
                >
                  <span className="text-lg">{language.flag}</span>
                  <span className="font-medium">{language.name}</span>
                  {i18n.resolvedLanguage === language.code && (
                    <i className="ri-check-line text-yellow-600 ms-auto"></i>
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
